/**
 * Onboarding account-setup step (APP-002 §8).
 *
 * Presents the account-name form prefilled with the current backend value.
 * This step is skippable (the welcome/next-action steps allow skipping past
 * it). The form sends ONLY `{ name }` (APP-002 §8, §33).
 */
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AccountNameForm } from '@/features/account/AccountNameForm';

export interface AccountSetupStepProps {
  initialName: string;
  onSaved: () => void;
  onSkip: () => void;
}

export function AccountSetupStep({ initialName, onSaved, onSkip }: AccountSetupStepProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <h2 className="text-xl font-semibold tracking-tight">Name your account</h2>
        <p className="text-sm text-muted-foreground">
          This name appears in your dashboard. You can change it later.
        </p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Account name</CardTitle>
          <CardDescription>
            Optional, but recommended so you can recognize this account.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <AccountNameForm initialName={initialName} onSuccess={onSaved} onCancel={onSkip} />
        </CardContent>
      </Card>
    </div>
  );
}
